// Aanmelden en abonnement (0065_abonnement). Handgeschreven zoals photoFrame.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/auth.ts en billing.ts); openapi.contract.test.ts bewaakt elke aanroep.
export function createSignupClient(t) {
    return {
        offer: () => t.request('GET', '/v1/app/auth/signup/offer'),
        start: (input) => t.request('POST', '/v1/app/auth/signup', input),
        verify: (code, trustThisBrowser = true) => t.request('POST', '/v1/app/auth/signup/verify', {
            code,
            trust_this_browser: trustThisBrowser,
        }),
        link: (token) => t.request('POST', '/v1/app/auth/signup/link', {
            token,
        }),
        resend: () => t.request('POST', '/v1/app/auth/challenge/resend', {}),
    };
}
export function createBillingClient(t) {
    return {
        get: () => t.request('GET', '/v1/app/billing'),
        checkout: (input) => t.request('POST', '/v1/app/billing/checkout', input),
        cancel: () => t.request('POST', '/v1/app/billing/cancel', { confirm: true }),
        resume: () => t.request('POST', '/v1/app/billing/resume', {}),
    };
}
//# sourceMappingURL=billing.js.map